<template>
  <div class="container-fluid">
    <refill-form />
  </div>
</template>

<script>
import RefillForm from "./views/RefillForm.vue"
export default {
  name: "App",

  components: {
    RefillForm
  },

  mounted() {},
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Ubuntu:wght@300&display=swap");
@font-face {
  font-family: "FontAwesome";
  src: url("/dialtech/fonts/fontawesome-webfont.eot?v=4.7.0");
  src: url("/dialtech/fonts/fontawesome-webfont.eot?#iefix&v=4.7.0")
      format("embedded-opentype"),
    url("/dialtech/template/fonts/fontawesome-webfont.woff2?v=4.7.0")
      format("woff2"),
    url("/dialtech/fonts/fontawesome-webfont.woff?v=4.7.0")
      format("woff"),
    url("http://prhz.pl/dialtech/template/plugins/fontawesome4/fonts/fontawesome-webfont.ttf?v=4.7.0")
      format("truetype");
  font-weight: normal;
  font-style: normal;
}
.table{
  min-width: 100% !important;
}
</style>
